import ICollectionParams from '../../models/params/ICollectionParams';
import { IFileCollection } from '../../models/collections/IFileCollection';
import { apiV2 } from '../../api/ApiV2';

export const filesPerPageValues = [36, 72, 144];
export const defaultFilesCollection: IFileCollection = {
  perPage: filesPerPageValues[0],
  pageNo: 1,
  sortColumn: 'ID',
  sortDirection: '-',
  totalCount: 0,
  itemsCount: 0,
  items: []
};

const FilesLoader = (
  collectionParams: ICollectionParams = defaultFilesCollection
) =>
  apiV2.crud
    .readCollection({
      dataObjectName: 'File',
      collectionParams: collectionParams
    })
    .then(resp => resp.itemsCollection as IFileCollection);

export default FilesLoader;
